import formatDate from '@anm/helpers/date/formatDate';
import { FC } from 'react';
import { Description, Title, Wrapper } from './styles';

type CmpProps = {
  title: string;
  scheduled?: string | null;
};

const ScheduledWebinar: FC<CmpProps> = ({ title, scheduled }) => {
  return (
    <Wrapper>
      <div>
        <Title dangerouslySetInnerHTML={{ __html: title }} />
        {scheduled && <Description>{formatDate(new Date(scheduled).getTime(), { isReplaceValue: false })}</Description>}
      </div>
    </Wrapper>
  );
};

export default ScheduledWebinar;
